import { createNamedContext } from '@utils';
import * as T from './interfaces';

export const FollowedTopicsContext = createNamedContext<T.FollowedTopicsContextValue | undefined>(undefined, 'FollowedTopics.Context');
export const SuggestedTopicsContext = createNamedContext<T.SuggestedTopicsContextValue | undefined>(undefined, 'SuggestedTopics.Context');

export const TopicItemContext = createNamedContext<T.TopicOverviewContextValue>(undefined, 'Topic.Overview.Context');
export const TopicMembersContext = createNamedContext<T.TopicMembersContextValue>(undefined, 'Topic.Members.Context');
export const TopicPostsContext = createNamedContext<T.TopicPostsContextValue>(undefined, 'Topic.Posts.Context');
export const TopicNewsContext = createNamedContext<T.TopicNewsContextValue | undefined>(undefined, 'Topic.News.Context');